
export default {
  props: {
    // 流程实例ID
    actInstId: {
      type: String
    },
    // 是否显示撤回按钮
    showRevokeBtn: {
      type: Boolean,
      default: true
    },
    // 是否显示修改审批人按钮
    showModifyBtn: {
      type: Boolean,
      default: true
    },
    modifyBtnText: {
      type: String,
      default: '修改审批人'
    },
    extraOrgId: {
      type: String,
      default: ''
    },
    extraRegId: {
      type: String,
      default: ''
    },
    extraCityId: {
      type: String,
      default: ''
    },
    revokeCallback: {
      type: Function,
      default: null
    },
    modifyUserCallback: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      trackArr: [],
      loading: false,
      activeName: ''
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/general-approve/flow-general-history/mixins/data.js
// module id = 18
// module chunks = 0